import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  InputSignalWithTransform,
  Signal,
  ViewEncapsulation
} from '@angular/core';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'tiime-slide-toggle-container',
  host: {
    class: 'tiime-slide-toggle-container',
    /* eslint-disable @typescript-eslint/naming-convention */
    '[class.small]': 'small()',
    '[class.large]': 'large()',
    '[class.selected]': 'selected()',
    '(click)': 'onClick()'
    /* eslint-enable @typescript-eslint/naming-convention */
  },
  templateUrl: './slide-toggle-container.component.html',
  styleUrls: ['slide-toggle-container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SlideToggleContainerComponent {
  readonly small: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly large: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly selected: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });

  protected readonly toggle: Signal<MatSlideToggle> = contentChild(MatSlideToggle);

  onClick(): void {
    if (!this.toggle()?.disabled) {
      this.toggle()?.toggle();
      this.toggle()?.change.emit(new MatSlideToggleChange(this.toggle(), this.toggle().checked));
    }
  }
}
